// Shared constants for the ideas feature

export const PLATFORMS = [
    { value: null, label: 'All Platforms', icon: '🌐' },
    { value: 'Instagram', label: 'Instagram', icon: '📸' },
    { value: 'LinkedIn', label: 'LinkedIn', icon: '💼' },
    { value: 'Twitter', label: 'Twitter / X', icon: '🐦' },
    { value: 'YouTube', label: 'YouTube', icon: '▶️' },
    { value: 'TikTok', label: 'TikTok', icon: '🎵' },
    { value: 'Facebook', label: 'Facebook', icon: '👥' },
];

export const FORMAT_COLORS = {
    'Short Post': '#6366f1',
    'Thread': '#8b5cf6',
    'Story': '#ec4899',
    'Reel/Video': '#ef4444',
    'Carousel': '#f59e0b',
    'Poll': '#10b981',
};

export const ENGAGEMENT_COLORS = {
    High: '#10b981',
    Medium: '#f59e0b',
    Low: '#9ca3af',
};

export const EXAMPLE_TOPICS = [
    'healthy recipes',
    'tech gadgets',
    'travel tips',
    'fitness motivation',
    'business strategies',
    'lifestyle hacks',
    'personal finance',
    'mental health',
    'photography tips',
    'remote work',
];

export const PLATFORM_COLORS = {
    Instagram: '#e1306c',
    LinkedIn: '#0077b5',
    Twitter: '#1da1f2',
    YouTube: '#ff0000',
    TikTok: '#010101',
    Facebook: '#1877f2',
    Pinterest: '#e60023',
    Reddit: '#ff4500',
};
